import type { PropertyID } from "@ext/properties/models";

export interface GroupLevel {
	id: PropertyID;
	from: string | null;
	to: string | null;
}

export type MoveArticleProperty = (
	articlePath: string,
	propertyName: PropertyID,
	from: string | null,
	to: string | null,
) => Promise<void>;

// Sequential: each write re-reads the article's properties from disk, so parallel writes lose each other.
const putArticleIntoGroup = async (
	articlePath: string,
	levels: GroupLevel[],
	move: MoveArticleProperty,
): Promise<void> => {
	for (const level of levels) {
		if (level.from === level.to) continue;
		await move(articlePath, level.id, level.from, level.to);
	}
};

export default putArticleIntoGroup;
